<template>
    <div id="WarehouseBinMapperCreate" class="fleet-form-main">
        <div :class="`loader${loaderClass}`" v-show="loading"></div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <span class="page-title" id="WarehouseBinMapperHeader" v-if="$route.params.id > 0">Update Warehouse Bin</span>
                    <span class="page-title" id="WarehouseBinMapperHeader" v-else>Add Warehouse Bin</span>
                    <!-- <span id="itemHeader" v-else>Add Component Transaction</span> -->
                    <button type="submit" class="btn btn-secondary pull-right" v-on:click.prevent="BackItemList" >
                            <i class="fp-back"> </i> Back
                    </button>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content component-inventory-crud">
                        <section class="internal-container border-top-table-fl">
                            <form autocomplete="off" class="form-horizontal basic-form-container form-custom-select" id="WarehouseBinMapperForm">
                                <div class="form-row row-cols-md-4">
                                    <div class="col form-group">
                                        <label class="control-label require" for="location_id">Warehouse:</label>
                                        <v-select v-model="warehouse_id" name="warehouse_id" placeholder="Select Warehouse."
                                                label="text" :disabled="$route.params.id != undefined"
                                                :options="warehouseArr">
                                        </v-select>
                                        <div class="field-error">{{warehouseerrors}}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label require" for="location_row">Location Row:</label>
                                        <input type="text" class="form-control" v-model="location_row" id="location_row" placeholder="Enter Location Row" name="location_row">
                                        <div class="field-error">{{rowerror}}</div>
                                    </div>

                                    <div class="col form-group">
                                        <label class="control-label require" for="location_bin">Location Bin:</label>
                                        <input type="text" class="form-control" v-model="location_bin" id="location_bin" placeholder="Enter Location Bin" name="location_bin">
                                        <div class="field-error">{{binerror}}</div>
                                    </div> 
                                    <div class="col form-group">
                                        <label class="control-label require" for="location_shelf">Location Shelf:</label>
                                        <input type="text" class="form-control" v-model="location_shelf" id="location_shelf" placeholder="Enter Location Shelf" name="location_shelf">
                                        <div class="field-error">{{shelferror}}</div>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <div class="alert alert-warning hide col-sm-6" id="alertError">
                                        <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                        <strong id="errorMsg" class="field-error"></strong>
                                    </div>
                                </div>
                                <div class="btn-groups">
                                    <button type="submit" id="CreateWarehouseBinBtn" v-if="$route.params.id > 0" class="btn btn-primary" v-on:click.prevent="CreateComponentTransaction" >
                                        <i class="fp-reload"> </i>  Update
                                    </button>
                                    <button type="submit" id="CreateWarehouseBinBtn" v-else class="btn btn-primary" v-on:click.prevent="CreateComponentTransaction" >
                                        <i class="fp-add"> </i>  Add
                                    </button>
                                    <button type="submit" id="cancelWarehouseBinBtn" class="btn btn-tertiary" v-on:click.prevent="goPreviousPath" >
                                    <i class="fp-close"> </i>  Cancel
                                    </button>
                                </div>
                            </form>
                        </section>        
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
    </div>
</template>
<script>
import Vue from "vue";

import {commonMixins} from '../../mixins/commonMixins';

import {contractMixins} from '../../mixins/contractMixins';
export default {
  name: "WarehouseBinMapperCreate",
  
  metaInfo() {
      return {title: (this.$route.params.id > 0)? "Update Warehouse Bin | " +process.env.COPYRIGHT_NAME : "Add Warehouse Bin | " +process.env.COPYRIGHT_NAME}
  },
  mixins:[commonMixins,contractMixins],
  data: () => ({
    permissions: [],
    cantAccessPage: "",
    location_row: "",
    location_shelf: "",
    location_bin: "",
    loading:false,
    warehouse_id:'',
    warehouseerrors:'',
    warehouseArr:[],
    rowerror:'',
    shelferror:'',
    binerror:''
  }),
    filters: {
        capitalize: function (value) {
            if (!value) return ''
            value = value.toString()
            return value.charAt(0).toUpperCase() + value.slice(1)
        }
    },
  watch:{
    //check permission change
    permissions: function (permissions) {

        var self = this;
        if (permissions.length > 0) {
            for (var i = 0; i < permissions.length; i++) {
                if (permissions[i].name == 'add_component_transaction' ) {
                    self.cantAccessPage = true;
                }
            }
        }

    }
  },
  created: function() {

  },
  mounted: function() {
        var self = this;
        // console.log("Default " + self.expenseValue);
        self.getPermissions();
        var path = window.location.pathname;
        var segments = path.split("/");
        
        if (segments[3]) {

            self.loadItem();
        } else {
        }
        this.loadFieldData(['warehouse']);

        if (self.$route.query.inv_id != undefined && self.$route.query.inv_id > 0){
            //self.fetchInventory();
        }else{
            var userObj = JSON.parse(localStorage.getItem("user_obj"));
            if(userObj != null && userObj["location_id"] != null){
                self.location_id =  {value: userObj["location_id"], text: self.titleCase(userObj["locationName"]) + " (" + userObj["locationCode"] + ")"};  
            }
        }
  },
  methods: {
    
    BackItemList() {
      var self = this;
     
        self.$router.push("/warehouse-bin-mapper/list");

    },
    
    CreateComponentTransaction(flag) {
        var self = this;
        var error = false;

        self.warehouseerrors = "";
        self.rowerror = "";
        self.shelferror = "";
        self.binerror = "";

        // if (self.location_row == '' && self.location_shelf == '' && self.location_bin == ''){
        //     self.rowshelfbinerror = 'Please add Row , Shelf Or Bin';
        //     error = true;
        // }

        if (self.location_row == ''){
            self.rowerror = 'Please add Row';
            error = true;
        }
        if (self.location_shelf == '' ){
            self.shelferror = 'Please add Shelf';
            error = true;
        }
        if (self.location_bin == ''){
            self.binerror = 'Please add Bin';
            error = true;
        }
        // var checkNumber = /^[0-9]+(\.[0-9]+)?$/;
        
        // if (self.base_price == "" && self.base_price != 0) {
        //     self.base_price_error_msg = "Base Price Required.";
        //     error = true;
        // } else {
            
        //     //check amount is valid or not
        //     if ( !String(self.base_price).match(checkNumber) ) {
        //         self.base_price_error_msg = "Base Price is not valid.";
        //         error = true;
        //     }
        // }
        if (self.warehouse_id == null || self.warehouse_id == '' || !self.warehouse_id.value) {
            self.warehouseerrors = "Warehouse Required.";
            error = true;
        } 
       
       
        if (!error) {

            var path = window.location.pathname;
            var segments = path.split("/");
            if (segments[3])
            {
                $("#CreateWarehouseBinBtn").val("Updating ...");
                $("#CreateWarehouseBinBtn").prop("disabled", true);
                $("#cancelWarehouseBinBtn").prop("disabled",true);
            }
            
            var fields = $("#WarehouseBinMapperForm").serializeArray();
            fields.push({ name: "id", value: segments[3] });
            fields.push({ name: "warehouse_id", value: self.warehouse_id.value });

            self.loading = true;
            $.ajax({
                url: process.env.ROOT_API + "/warehouse-bin-mapper/create",
                type: "POST",
                data: fields,
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {

                    self.loading = false;
                    if (segments[3])
                    {
                        $("#CreateComponentInventoryBtn").val("Update");
                        $("#CreateComponentInventoryBtn").prop("disabled", false);
                        $("#cancelItemBtn").prop("disabled",false);
                    }
                    if (data.status == "success") {

                            self.$router.push("/warehouse-bin-mapper/list");

                    } else {
                        if (data.content.length > 0) {
                            var err = "";
                            for (var i = 0; i < data.content.length; i++) {
                                err += data.content[i] + "<br>";
                            }
                            $("#errorMsg").html(err);
                            $(".alert-warning").toggleClass("show");
                            setTimeout(function () {
                                $(".alert-warning").removeClass("show");
                                $(".alert-warning").addClass("hide");
                            }, 10000);
                        }
                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    if (segments[3])
                    {
                        $("#CreateWarehouseBinBtn").val("Update");
                        $("#CreateWarehouseBinBtn").prop("disabled", false);
                        $("#cancelWarehouseBinBtn").prop("disabled",false);
                    }
                    self.generateStatusCodeMessage(jqXHR,true,'component-create')
                }
            });
        }else{
            self.errorValidationFocus();
        }

    },

    loadItem() {
        
        var path = window.location.pathname;
        var segments = path.split("/");
        var self = this;
        self.loading = true;
        
        $.ajax({
            url: process.env.ROOT_API + "/warehouse-bin-mapper/" + segments[3],
            type: "GET",
            headers: this.ajxHeaders,
            dataType: "json",
            success: function (data) {
                self.loading = false;
                // console.log(data);
                if (data.status == "success") {

                    if(data.content.warehouse_id == null) {
                        self.warehouse_id = null;
                    }else{
                        self.warehouse_id = {value: data.content.warehouse_id, text: self.titleCase(data.content.warehouseCode + " (" + data.content.warehouseName +")")};
                    }

                    if (data.content.row == 0) {
                        self.location_row = "";
                    } else{
                        self.location_row = data.content.row;
                    }

                    if (data.content.bin == 0) {
                        self.location_bin = "";
                    } else{
                        self.location_bin = data.content.bin;
                    }

                    self.location_shelf = data.content.shelf;
                    
                } 
            },
            error: function (jqXHR, exception) {
                self.loading = false;
                self.generateStatusCodeMessage(jqXHR,false,'warehouse-bin-by-id')
            }
        });
    },
    
    isNumberKey: function(evt) {
        
        var self = this;

        evt = (evt) ? evt : window.event;
        var charCode = (evt.which) ? evt.which : evt.keyCode;
        if ((charCode > 31 && (charCode < 48 || charCode > 57)) && (charCode !== 46 || evt.target.value.indexOf('.') != -1)) {
            evt.preventDefault();            
        } else {
            return true;
        }
    },
    titleCase(str) {
        if (str == null){
            return;
        } else{
            var value = str.toString()
            return value.charAt(0).toUpperCase() + value.slice(1)
        }
    },
  }
};
</script>


// WEBPACK FOOTER //
// src/components/warehouse/WarehouseBinMapperCreate.vue